import { useTranslation } from "react-i18next";
import { FilterPills } from "./FilterPills";
import { SignalListRow } from "./SignalListRow";
import {
  categoryLabelKey,
  groupPlaybooks,
  filterPlaybooks,
} from "./playbookUtils";

export const SignalList = ({
  playbooks,
  filter,
  selectedSignalType,
  isDirty,
  onFilterChange,
  onSelect,
}) => {
  const { t } = useTranslation();

  const total = playbooks.length;
  const nCustomized = playbooks.filter((p) => p.source === "team").length;
  const nOff = playbooks.filter((p) => !p.is_enabled).length;

  const filtered = filterPlaybooks(playbooks, filter);
  const groups = groupPlaybooks(filtered);

  return (
    <div className="flex w-full flex-col bg-white lg:w-[320px] lg:flex-none lg:border-r lg:border-gray-200">
      <div className="border-b border-gray-100 p-4">
        <h2 className="mb-1 text-base font-bold text-gray-900">
          {t("pages.settings.signalsPlaybooks.title")}
        </h2>
        <p className="mb-3 text-xs text-gray-400">
          {t("pages.settings.signalsPlaybooks.summaryLine", {
            total,
            customized: nCustomized,
            off: nOff,
          })}
        </p>
        <FilterPills
          filter={filter}
          counts={{ all: total, customized: nCustomized, off: nOff }}
          onChange={onFilterChange}
        />
      </div>

      <div className="flex-1 overflow-y-auto p-2.5">
        {groups.length === 0 && (
          <p className="p-4 text-center text-xs text-gray-400">
            {t("pages.settings.signalsPlaybooks.list.emptyFilter")}
          </p>
        )}
        {groups.map((group) => (
          <div key={group.key} className="mt-2.5 first:mt-0">
            <div className="px-2.5 pb-1 pt-1.5 text-[11px] font-bold uppercase tracking-wide text-gray-400">
              {t(
                `pages.settings.signalsPlaybooks.categories.${categoryLabelKey(group.key)}`,
              )}
            </div>
            {group.items.map((signal) => (
              <SignalListRow
                key={signal.signal_type}
                signal={signal}
                isSelected={selectedSignalType === signal.signal_type}
                isDirty={isDirty(signal.signal_type)}
                onSelect={onSelect}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
